export const menuItems = [
  {
    value: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
    mobile: true
  },
  {
    value: "agenda",
    label: "Agenda",
    path: "/agenda",
    mobile: true
  },
  {
    value: "crm",
    label: "CRM",
    path: "/crm",
    mobile: true
  },
  {
    value: "financeiro",
    label: "Financeiro",
    path: "/financeiro",
    mobile: false
  },

];